'use client';

import { useRef, type MouseEvent, type CSSProperties } from 'react';
import { useInView } from 'framer-motion';
import Link from 'next/link';

interface ServiceCardProps {
  index: number;
  tag: string;
  title: string;
  description: string;
  href: string;
}

/** Combines scripts.js banners 6 (reveal) + 11 (card glow) on the index service cards. */
export default function ServiceCard({ index, tag, title, description, href }: ServiceCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.15, margin: '0px 0px -50px 0px' });

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mouse-x', `${e.clientX - rect.left}px`);
    el.style.setProperty('--mouse-y', `${e.clientY - rect.top}px`);
  };

  return (
    <div
      ref={ref}
      className={`service-card reveal${isInView ? ' active' : ''}`}
      style={{ '--i': index } as CSSProperties}
      onMouseMove={handleMouseMove}
    >
      <div className="service-info">
        <span>{tag}</span>
        <h3>{title}</h3>
        <p className="service-description">{description}</p>
        <Link href={href} className="service-card-btn">
          Ver más
        </Link>
      </div>
    </div>
  );
}
